import React, { useState, useRef, useEffect } from "react";
import image from "./../images/image.png";
import { useNavigate } from "react-router-dom"; // Added for Log Out navigation

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const menuRef = useRef(null);
  const navigate = useNavigate(); // Added for navigation on logout

  // Close the menu if user clicks outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleItemClick = (item) => {
    setActiveItem((prev) => (prev === item ? null : item));
  };

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem("userData"); // Clear token
    navigate("/login"); // Redirect to login
    setOpen(false); // Close dropdown
  };

  // Define menu items with unique Tabler Icons
  const menuItems = [
    {
      id: "profile",
      label: "My Profile",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5 mr-3"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="12" cy="7" r="4" />
          <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
        </svg>
      ),
    },
    {
      id: "account",
      label: "My Account",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5 mr-3"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <polyline points="3 7 12 13 21 7" />
        </svg>
      ),
    },
    {
      id: "task",
      label: "My Task",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5 mr-3"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
          <rect x="9" y="3" width="6" height="4" rx="2" />
          <path d="M9 14l2 2l4 -4" />
        </svg>
      ),
    },
  ];

  return (
    <div className="flex items-center justify-end gap-3 p-2 relative">
      {/* Log Out button */}
      <button
        onClick={handleLogout}
        className="bg-blue text-white px-4 py-[6px] rounded-md hover:bg-blue-700 transition"
      >
        Log Out
      </button>

      {/* Avatar button */}
      <div className="relative" ref={menuRef}>
        <button onClick={() => setOpen((prev) => !prev)}>
          <img
            className="w-9 h-9 rounded-full cursor-pointer border border-[1px] border-[#f9f7f7] object-contain"
            src={image}
            alt="Avatar"
          />
        </button>

        {/* Dropdown menu */}
        {open && (
          <div className="absolute right-0 mt-2 w-44 bg-white border border-gray-200 rounded-xl shadow-lg z-50">
            <ul className="flex flex-col text-sm text-gray-700">
              {menuItems.map((item) => (
                <li
                  key={item.id}
                  onClick={() => handleItemClick(item.id)}
                  className={`px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center rounded-md transition ${
                    activeItem === item.id ? "text-blue" : "text-gray-800"
                  }`}
                >
                  {item.icon}
                  <span className="font-medium">{item.label}</span>
                </li>
              ))}
              <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                <button
                  onClick={handleLogout}
                  className="bg-blue text-white w-[100%] m-auto py-[6px] rounded-md hover:bg-blue-700 transition flex items-center justify-center gap-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
                    <path d="M7 12h14l-3 -3m0 6l3 -3" />
                  </svg>
                  Log Out
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
